module.exports = __webpack_public_path__ + "img/BB.71da99ed.svg";